import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";

export default function AuthStepRoute() {
  const { accessToken, type, status } = useAuthStore();
  const location = useLocation();

  // Belum login → tendang ke login
  if (!accessToken || !type) {
    return <Navigate to={location.pathname.startsWith("/id") ? "/id/login" : "/en/login"} replace />;
  }

  // USER flow
  if (type === "candidate") {
    if (status === true) {
      return <Navigate to="user/user-dashboard" replace />;
    }
    return <Outlet />; // status false → izinkan masuk ke OTP/personal-information
  }

  // ADMIN flow
  if (type === "company") {
    if (status === true) {
      return <Navigate to="admin/company-profile" replace />;
    }
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
}
